export enum Type {
  APPLICATION = 'innoctopus:2.0:application',
  PAGE = 'innoctopus:2.0:page',
}
